<template>
  <div class="mainCon">
    <stu-main-title></stu-main-title>
    <div class="content">
      <div class="sign-bottom" v-if="noticeList.length">
        <div class="sign-bottom-main">
          <ul>
            <li
              v-for="(item, index) in noticeList"
              :key="index"
              v-show="item.noticeStatus == 50"
            >
              <div
                :class="[
                  item.isRead == 'true' ? 'is_notice' : '',
                  'noticeBorder',
                ]"
              >
                <a href="javascript:void(0);" @click="Notice(item.id)">{{
                  item.title
                }}</a>
                <!-- 鼠标悬浮 -->
                <div class="noticeHover">{{ item.title }}</div>
                <!-- 隐藏下载 icon -->
                <span
                  @click="downloadNotice(item + 1)"
                  style="color: red"
                  v-if="false"
                  >icon</span
                >
              </div>

              <span class="sign-bottom-main-data"
                ><span style="margin-right：16px;display:inline-block;"
                  >发布人：{{ item.issuerName }}</span
                >{{ item.releaseTime }}</span
              >
            </li>
          </ul>
        </div>
        <div class="page">
          <!-- 分页 -->
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pagination.size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pagination.total"
            v-if="pagination.total > 0"
          >
          </el-pagination>
        </div>
      </div>
      <div v-else class="noScore">
        <img src="@/assets/stuImg/nothing.png" alt="" />
        <span class="col_grayQ">暂无公告，请等待</span>
      </div>
    </div>
  </div>
</template>
<script>
import { selectNoticeListInfo } from "@/http/modules/student/notice";
export default {
  name: "stuNotice",
  data() {
    return {
      currentPage: 1,
      pagination: {
        total: 0,
        size: 10,
      },
      noticeList: "",
    };
  },

  mounted() {
    this.getNotice();
  },
  methods: {
    /*********************************
     * @this 分页...
     *********************************/
    handleSizeChange(num) {
      this.pagination.size = num;
      this.getNotice();
    },

    handleCurrentChange(p) {
      this.currentPage = p;
      this.getNotice();
    },

    /*********************************
     * @this 公告列表点击事件,跳转对应的公告页面,将公告id传入
     *********************************/
    Notice(e) {
      this.$router.push("/stuHome/stuNoticeInfo?id=" + e);
    },

    /*********************************
     * @this 获取公告列表数据
     *********************************/
    async getNotice() {
      let params = {
        isFrom: "50",
        page: this.currentPage,
        size: this.pagination.size,
        planId: this.getCurrentGlobalPlanId(),
      };
      const { data } = await selectNoticeListInfo(params);
      data.records.forEach((e) => {
        e.releaseTime = e.releaseTime.slice(0, 10);
      });
      this.pagination.total = data.total;
      this.noticeList = data.records;
    },
  },
};
</script>
<style lang="less" scoped>
.mainCon {
  box-sizing: border-box;
  padding: 20px;
  padding-top: 16px;
  width: 100%;
  min-width: 700pt;
  background: rgba(255, 255, 255, 0.93);
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.5);
  .content {
    .noScore {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-top: 40px;
      padding-bottom: 80px;
    }
    .el-pagination {
      display: flex;
      justify-content: center;
      margin-top: 32px;
      /deep/ .is-in-pagination {
        .el-input__inner {
          padding: 0 3px !important;
          width: 100%;
          height: 28px;
          line-height: 28px;
        }
      }
      /* 表单设置统一样式 */
      /deep/ .el-input {
        height: 28px;
        line-height: 28px;
        .el-input__inner {
          padding: 0 13px 0 3px !important;
          box-sizing: border-box;
          width: 100%;
          height: 28px;
          line-height: 28px;
        }
      }
    }
    /* 选中 type="number" 标签 */
    /deep/ .el-input {
      height: 28px;
      line-height: 28px;
      .el-input__inner[type="number"] {
        padding: 0 3px 0 3px !important;

        box-sizing: border-box;
        width: 100%;
        height: 28px;
        line-height: 28px;
      }
    }
    /deep/ .el-input__inner {
      padding: 0px !important;
    }
    /deep/ .el-input__suffix {
      display: flex;
      justify-content: center;
      align-items: center;
      padding-top: 2px;
      box-sizing: border-box;
    }
  }
}
/* ***** 院校公告 ***** */
.sign-bottom {
  width: 100%;
  height: auto;
  border-radius: 8px;
  background-color: #fff;
  margin-top: 24px;
  padding: 30px 40px;
  box-sizing: border-box;

  .sign-bottom-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    span {
      font-size: 18px;
      color: #2d2f33;
      font-weight: 600;
    }
    a {
      text-decoration: none;
      color: #737780;
      font-size: 14px;
    }
  }

  .sign-bottom-main {
    ul {
      li {
        font-size: 14px;
        height: 58px;
        border-bottom: 1px #f1f2f5 dotted;
        display: flex;
        justify-content: space-between;

        .noticeBorder {
          width: 45%;
          height: 58px;
          display: flex;
          align-items: center;
          position: relative;

          a {
            display: inline-block;
            color: #45494d;
            line-height: 58px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            -o-text-overflow: ellipsis;
            max-width: calc(100% - 60px);
          }

          .noticeHover {
            padding: 0 8px;
            width: auto;
            display: none;
          }

          /* ***** 鼠标悬浮显示全部内容 ***** */
          a:hover + .noticeHover {
            display: block;
            position: absolute;
            background-color: #eee;
            border: 1px solid #737780;
            border-radius: 4px;
            bottom: 100%;
            left: 16px;
          }

          span {
            margin-left: 8px;
            display: inline-block;
            cursor: pointer;
          }
        }

        .noticeBorder::before {
          content: "";
          display: inline-block;
          width: 5px;
          height: 5px;
          margin-right: 7px;
          background: #fe5958;
          border-radius: 50%;
        }
        .is_notice {
          a {
            color: #9299a6;
          }
          span {
            color: #9299a6;
          }
        }

        .is_notice::before {
          content: "";
          display: inline-block;
          width: 5px;
          height: 5px;
          margin-right: 7px;
          background: #c2c6cc;
          border-radius: 50%;
        }
        .sign-bottom-main-data {
          display: inline-block;
          color: #737780;
          line-height: 58px;
          span {
            display: inline-block;
            margin-right: 16px;
          }
        }
      }
    }
  }
}
</style>
